import { render, staticRenderFns } from "./phoneCodeDialog.vue?vue&type=template&id=78116550&scoped=true&"
import script from "./phoneCodeDialog.vue?vue&type=script&lang=ts&"
export * from "./phoneCodeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./phoneCodeDialog.vue?vue&type=style&index=0&id=78116550&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78116550",
  null
  
)

export default component.exports